import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { login } from "../store/actions/AuthAction";
import { bindActionCreators } from "redux";

const styles = theme => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  }
});

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      usuario: "",
      senha: ""
    };

    this.onChange = this.onChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  onChange(event) {
    return this.setState({
      [event.target.name]: event.target.value
    });
  }

  onLogin(event) {
    event.preventDefault();
    var str = window.location.href;
    var str1 = str.substr(str.indexOf("/faturamento/") + 13, 40);
    console.log(str1);
    this.props.login(this.state.usuario, this.state.senha, this.getDomain());
  }

  getDomain = () => {
    var full = window.location.host;
    var parts = full.split(".");
    return parts[0];
  };

  render() {
    const { classes } = this.props;
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    sessionStorage.setItem("fatura", from.pathname.substr(13, 40));
    return (
      <main className={classes.main}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="usuario">Usuário</InputLabel>
            <Input
              id="usuario"
              name="usuario"
              autoComplete="usuario"
              autoFocus
              value={this.state.usuario}
              onChange={this.onChange}
            />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="senha">Senha</InputLabel>
            <Input
              value={this.state.senha}
              onChange={this.onChange}
              name="senha"
              type="password"
              id="senha"
              autoComplete={"new-password"}
            />
          </FormControl>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={this.onLogin}
          >
            Entrar
          </Button>
        </Paper>
        <Typography
          component="h6"
          variant="subtitle2"
          color="error"
          align="center"
        >
          {this.props.authentication.err}
        </Typography>
      </main>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ login }, dispatch);
}

const mapStateToProps = state => ({
  authentication: state.authentication
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Login));
